<div [ngClass]="cssClass" class="booking-confirmation p-6">
  <div class="booking-confirmation__close">
    <button (click)="close()" class="icon-button" type="button">
      <app-ui-icon color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </button>
  </div>

  <div class="booking-confirmation__card">
    <div class="booking-confirmation__card__img">
      <img [src]="imgUrl" alt="confirm">
    </div>
    <div class="booking-confirmation__card__header">Tack för din bokning!</div>
    <div class="booking-confirmation__card__subheader">
      En bekräftelse har skickats till din email.
    </div>
    <div class="booking-confirmation__card__delimiter"></div>
    <div class="booking-confirmation__card__careprovider">
      {{ data.careProviderUnitName }}
    </div>
    <div class="booking-confirmation__card__service">
      {{ data.serviceName }}
    </div>
    <div class="booking-confirmation__card__appointment">
      {{ appointmentToDisplay }}
    </div>
    <div class="booking-confirmation__card__price-terapeut">
      <div
        *ngIf="!isPriceEmpty"
        [ngClass]="{'is-from-price': data.isFromPrice}"
        class="booking-confirmation__card__price"
      >
        {{ formattedPrice }}
      </div>
      <div
        *ngIf="showPriceDelimiter"
        class="booking-confirmation__card__delimiter-vert"
      ></div>
      <div class="booking-confirmation__card__terapeut">
        {{ data.terapeutName }}
      </div>
    </div>
  </div>

  <div class="booking-confirmation__submit-button">
    <app-ui-button
      (onClick)="close()"
      [color]="'green'"
      [compressed]="false"
      [expanded]="'block'"
      [size]="'lg'"
      class="varden-btn__narrow"
    >
      STÄNG
    </app-ui-button>
  </div>
</div>
